import React from "react";
import { COLOR_BLOCKS } from "../lib/colorBlocks";
import { normalizeHex } from "../lib/harmonicPalette";

const ColorBlockPicker = ({
  value,
  onSelect,
  labelledBy,
  extraColors = [],
}) => {
  const selected = normalizeHex(value) || "#000000";
  const extras = extraColors
    .map((hex) => normalizeHex(hex))
    .filter((hex) => hex && !COLOR_BLOCKS.includes(hex));
  const blocks = extras.length > 0 ? [...extras, ...COLOR_BLOCKS] : COLOR_BLOCKS;

  return (
    <div
      className="color-block-picker"
      role="listbox"
      aria-labelledby={labelledBy}
      aria-label={labelledBy ? undefined : "Color blocks"}
    >
      {blocks.map((hex) => {
        const isSelected = hex === selected;
        return (
          <button
            key={hex}
            type="button"
            role="option"
            aria-selected={isSelected}
            aria-label={hex}
            className={`color-block-picker__swatch${
              isSelected ? " is-selected" : ""
            }`}
            style={{ backgroundColor: hex }}
            onClick={(event) => {
              event.stopPropagation();
              onSelect(hex);
            }}
          />
        );
      })}
    </div>
  );
};

export default ColorBlockPicker;
